import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {SeguridadService} from '@servicios/Seguridad.service';

import {TipodepartamentoComponent} from './tipodepartamento/tipodepartamento.component';
import {OrganizacionComponent} from './organizacion/organizacion.component';
import {ColaboradorComponent} from './colaborador/colaborador.component';

const routes: Routes = [
    {path: '', redirectTo: 'tipodepartamento', pathMatch: 'full'},
    {path: 'tipodepartamento', component: TipodepartamentoComponent, data: {modulo: 'app'}, canActivate: [SeguridadService]},
    {path: 'organizacion', component: OrganizacionComponent, data: {modulo: 'app'}, canActivate: [SeguridadService]},
    {path: 'colaborador', component: ColaboradorComponent, data: {modulo: 'app'}, canActivate: [SeguridadService]},
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class ConfiguracionRHRoutingModule {}
